// Recent websites, shown on /projects and in the homepage "Recent work" section
export type Project = {
  name: string;
  url: string;
  domain: string;
  image: string;
  category: string;
  summary: string;
};

export const projects: Project[] = [
  {
    name: 'CleanOn',
    url: 'https://cleanon.com.au',
    domain: 'cleanon.com.au',
    image: '/work/cleanon-desktop.webp',
    category: 'Booking platform',
    summary: 'Sydney cleaning booking platform: end-of-lease, carpet, oven and regular cleaning with instant quotes.',
  },
  {
    name: 'CASHO',
    url: 'https://www.casho.com.au',
    domain: 'casho.com.au',
    image: '/work/casho-desktop.webp',
    category: 'Web app',
    summary: 'Shared household finance app: income, spending, budgets and subscriptions in one real-time dashboard.',
  },
  {
    name: 'skillshift',
    url: 'https://www.skillshift.com.au',
    domain: 'skillshift.com.au',
    image: '/work/skillshift-desktop.webp',
    category: 'Consultancy site',
    summary: 'Digital transformation and business consulting, including the Global SEO Affordability Study.',
  },
  {
    name: 'People Relations',
    url: 'https://peoplerelations.com.au',
    domain: 'peoplerelations.com.au',
    image: '/work/peoplerelations-desktop.webp',
    category: 'Business website',
    summary: 'HR consulting firm in North Sydney: recruitment, HR systems, payroll and employee management.',
  },
];
